module.exports = __webpack_public_path__ + "5b43d0ba4de10ef3055753765192fdfd.MP3";